<template>
  <v-card flat ref="comment" :max-width="maxWidth">
    <v-card-title>
      <v-text-field
        outlined
        append-icon="mdi-send"
        label="댓글 작성"
        placeholder="짧은 댓글을 남겨보세요~"
        hide-details
        @keypress.enter="save"
        @click:append="save"
        v-model="comment"
      ></v-text-field>
    </v-card-title>
    <template v-for="(item, i) in items">
      <!-- <v-divider :key="i" v-if="i > 0"></v-divider> -->
      <v-list-item :key="item.id" two-line>
        <v-list-item-action>
          <v-chip color="primary" v-if="!$vuetify.breakpoint.xs">
            <v-avatar left>
              <v-img v-if="item.photoURL" :src="item.photoURL"></v-img>
              <v-icon v-else>mdi-lock-open</v-icon>
            </v-avatar>
            <span>{{item.email}}</span>
          </v-chip>
          <v-avatar v-else>
            <v-img v-if="item.photoURL" :src="item.photoURL"></v-img>
            <v-icon v-else>mdi-lock-open</v-icon>
          </v-avatar>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-subtitle>
            <v-tooltip bottom v-if="item.text.length > 40">
              <template v-slot:activator="{ on }">
                <span v-on="on" v-text="item.text"></span>
              </template>
              <span v-text="item.text"></span>
            </v-tooltip>
            <span v-else v-text="item.text"></span>
          </v-list-item-subtitle>
          <v-list-item-subtitle><display-time :time="item.createdAt" /></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="$store.state.fireUser && $store.state.fireUser.uid === item.uid">
          <v-btn icon @click="remove(item)" color="error"><v-icon>mdi-delete</v-icon></v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider :key="i" v-if="i < items.length - 1" />
    </template>
    <v-card-actions class="text-center" v-if="items.length < article.countComment">
      <v-row justify="center">
        <!-- //  v-intersect="onIntersect" -->
        <v-btn text block @click="subscribe" v-intersect="onIntersect" color="accent" :loading="loading">
          더보기
        </v-btn>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import DisplayTime from '@/components/display-time'

export default {
  components: { DisplayTime },
  props: ['article', 'refArticle', 'id'],
  data () {
    return {
      comment: '',
      items: [],
      unsubscribe: null,
      loading: false,
      limit: 4,
      refComments: null,
      maxWidth: null
    }
  },
  // watch: {
  //   id (n) {
  //     // this.subscribe()
  //   }
  // },
  created () {
    if (!this.article.countComment) this.subscribe()
  },
  mounted () {
    this.maxWidth = this.$refs.comment.$el.clientWidth
  },
  destroyed () {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    onError (e) {
      this.loading = false
      this.$toast.error(e.message)
    },
    subscribe () {
      this.loading = true
      this.refComments = this.refArticle.doc(this.id).collection('comments')
      this.unsubscribe = this.refComments.orderBy('createdAt', 'desc').limit(this.limit).onSnapshot((sn) => {
        this.loading = false
        if (sn.empty) {
          this.items = []
          return
        }
        this.docs = sn.docs
        const items = sn.docs.map(doc => {
          const item = doc.data()
          item.id = doc.id
          item.createdAt = item.createdAt.toDate()
          item.updatedAt = item.updatedAt.toDate()
          return item
        })
        this.items = items
        if (this.limit > 100) return
        if (this.items.length === this.limit) this.limit += 4
      }, this.onError)
    },
    save () {
      if (!this.comment) throw Error('빈 글은 허용하지 않습니다')
      if (this.comment.length > 80) throw Error('80 글자 이내여야 합니다')
      if (!this.$store.state.fireUser) throw Error('로그인해야 작성됩니다')
      try {
        const uid = this.$store.state.fireUser ? this.$store.state.fireUser.uid : null
        const email = this.$store.state.fireUser ? this.$store.state.fireUser.email : null
        const photoURL = this.$store.state.fireUser ? this.$store.state.fireUser.photoURL : null
        const comment = {
          uid,
          email,
          photoURL,
          text: this.comment,
          createdAt: new Date(),
          updatedAt: new Date()
        }
        this.refComments.add(comment)
      } finally {
        this.comment = ''
      }
    },
    onIntersect (entries, observer, isIntersecting) {
      // console.log(entries, observer, isIntersecting)
      if (isIntersecting) this.subscribe()
    },
    async remove (item) {
      const r = await this.$swal.fire({
        title: '정말 삭제하시겠습니까?',
        text: '삭제 후 되돌릴 수 없습니다.',
        icon: 'error',
        // confirmButtonText: 'Cool',
        showCancelButton: true
      })
      if (!r.value) return
      await this.refComments.doc(item.id).delete()
    }
  }
}
</script>
